import app from "../app";
import {PhotolabTaskBuilder} from "@vicman-wi/photolab-api-js";

export function photolabTask(taskConfig, optionsArg) {
  return app.photolabApi.task(taskConfig, {
    delay: optionsArg?.timeout,
    interval: optionsArg?.interval,
    ...optionsArg,
  });
}

export function photolabAddTask(taskConfig) {
  return app.photolabApi.addTask(taskConfig);
}

export function photolabWaitTask(requestId, timeout = 0, interval = 1000) {
  return app.photolabApi.waitTask(requestId, {
    timeout,
    interval,
  });
}

export async function photolabSimpleTask(templateId, imageObjectOrUrl, timeout = 1000, interval = 500) {
  const config = new PhotolabTaskBuilder()
    .addCollageMethod({template_name: templateId})
    .addImage(imageObjectOrUrl)
    .setLanguage(window.clientConfig.lang)
    .build();

  const taskResult = await photolabTask(config, {
    interval,
    timeout,
  });
  return taskResult;
}
